export default function getSerializedQueryArgs({
  endpointName,
  queryArgs,
}: {
  endpointName: string;
  queryArgs: Record<string, unknown>;
}) {
  let result = endpointName;

  Object.keys(queryArgs || {}).forEach((key) => {
    result = `${result}-(${key}=${queryArgs[key]})`;
  });

  return result;
}
